import defaultCover from '@/assets/default-cover.svg';

export const getArticleCover = (coverImage) => coverImage || defaultCover;
